"use strict";

var _inherits = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _createSuper = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");
var _classCallCheck = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ISO_2022_CN = exports.ISO_2022_KR = exports.ISO_2022_JP = void 0;
var match_1 = __importDefault(require("../match"));
var ISO_2022 = /*#__PURE__*/function () {
  function ISO_2022() {
    _classCallCheck(this, ISO_2022);
    this.escapeSequences = [];
  }
  _createClass(ISO_2022, [{
    key: "name",
    value: function name() {
      return 'ISO_2022';
    }
  }, {
    key: "match",
    value: function match(det) {
      var i, j;
      var escN;
      var hits = 0;
      var misses = 0;
      var shifts = 0;
      var confidence;
      var text = det.inputBytes;
      var textLen = det.inputLen;
      scanInput: for (i = 0; i < textLen; i++) {
        if (text[i] == 0x1b) {
          checkEscapes: for (escN = 0; escN < this.escapeSequences.length; escN++) {
            var seq = this.escapeSequences[escN];
            if (textLen - i < seq.length) continue checkEscapes;
            for (j = 1; j < seq.length; j++) {
              if (seq[j] != text[i + j]) continue checkEscapes;
            }
            hits++;
            i += seq.length - 1;
            continue scanInput;
          }
          misses++;
        }
        if (text[i] == 0x0e || text[i] == 0x0f) shifts++;
      }
      if (hits == 0) return null;
      confidence = (100 * hits - 100 * misses) / (hits + misses);
      if (hits + shifts < 5) confidence -= (5 - (hits + shifts)) * 10;
      return confidence <= 0 ? null : (0, match_1.default)(det, this, confidence);
    }
  }]);
  return ISO_2022;
}();
var ISO_2022_JP = /*#__PURE__*/function (_ISO_) {
  _inherits(ISO_2022_JP, _ISO_);
  var _super = _createSuper(ISO_2022_JP);
  function ISO_2022_JP() {
    var _this;
    _classCallCheck(this, ISO_2022_JP);
    _this = _super.apply(this, arguments);
    _this.escapeSequences = [[0x1b, 0x24, 0x28, 0x43], [0x1b, 0x24, 0x28, 0x44], [0x1b, 0x24, 0x40], [0x1b, 0x24, 0x41], [0x1b, 0x24, 0x42], [0x1b, 0x26, 0x40], [0x1b, 0x28, 0x42], [0x1b, 0x28, 0x48], [0x1b, 0x28, 0x49], [0x1b, 0x28, 0x4a], [0x1b, 0x2e, 0x41], [0x1b, 0x2e, 0x46]];
    return _this;
  }
  _createClass(ISO_2022_JP, [{
    key: "name",
    value: function name() {
      return 'ISO-2022-JP';
    }
  }, {
    key: "language",
    value: function language() {
      return 'ja';
    }
  }]);
  return ISO_2022_JP;
}(ISO_2022);
exports.ISO_2022_JP = ISO_2022_JP;
var ISO_2022_KR = /*#__PURE__*/function (_ISO_2) {
  _inherits(ISO_2022_KR, _ISO_2);
  var _super2 = _createSuper(ISO_2022_KR);
  function ISO_2022_KR() {
    var _this2;
    _classCallCheck(this, ISO_2022_KR);
    _this2 = _super2.apply(this, arguments);
    _this2.escapeSequences = [[0x1b, 0x24, 0x29, 0x43]];
    return _this2;
  }
  _createClass(ISO_2022_KR, [{
    key: "name",
    value: function name() {
      return 'ISO-2022-KR';
    }
  }, {
    key: "language",
    value: function language() {
      return 'kr';
    }
  }]);
  return ISO_2022_KR;
}(ISO_2022);
exports.ISO_2022_KR = ISO_2022_KR;
var ISO_2022_CN = /*#__PURE__*/function (_ISO_3) {
  _inherits(ISO_2022_CN, _ISO_3);
  var _super3 = _createSuper(ISO_2022_CN);
  function ISO_2022_CN() {
    var _this3;
    _classCallCheck(this, ISO_2022_CN);
    _this3 = _super3.apply(this, arguments);
    _this3.escapeSequences = [[0x1b, 0x24, 0x29, 0x41], [0x1b, 0x24, 0x29, 0x47], [0x1b, 0x24, 0x2a, 0x48], [0x1b, 0x24, 0x29, 0x45], [0x1b, 0x24, 0x2b, 0x49], [0x1b, 0x24, 0x2b, 0x4a], [0x1b, 0x24, 0x2b, 0x4b], [0x1b, 0x24, 0x2b, 0x4c], [0x1b, 0x24, 0x2b, 0x4d], [0x1b, 0x4e], [0x1b, 0x4f]];
    return _this3;
  }
  _createClass(ISO_2022_CN, [{
    key: "name",
    value: function name() {
      return 'ISO-2022-CN';
    }
  }, {
    key: "language",
    value: function language() {
      return 'zh';
    }
  }]);
  return ISO_2022_CN;
}(ISO_2022);
exports.ISO_2022_CN = ISO_2022_CN;